import { useState } from 'react';

// True on the first render and on every render where an input differs (by
// Object.is, so NaN equals itself) from the previous render's. For adjusting
// state during render rather than in an effect: React re-renders straight
// away with the state set under `if (useInputsChanged([...]))`, before
// committing.
// https://react.dev/learn/you-might-not-need-an-effect#adjusting-some-state-when-a-prop-changes
const useInputsChanged = (inputs: readonly unknown[]): boolean => {
  const [prevInputs, setPrevInputs] = useState<readonly unknown[] | null>(
    null,
  );
  const changed =
    !prevInputs ||
    prevInputs.length !== inputs.length ||
    inputs.some((input, index) => !Object.is(input, prevInputs[index]));
  if (changed) setPrevInputs(inputs);
  return changed;
};

export default useInputsChanged;
